export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/searchWorker.36e5a842.worker.js");
}
